import { gql } from "@apollo/client";
import { lensCompoundIdFragment } from "../fragments/lensCompoundIdFragment";

export const saveLensMutation = gql`
    mutation saveLens(
        $lensCompoundId: InputLensCompoundId!
        $vendorData: [InputVendorDataItem]!
        $organizationId: String = null
    ) {
        saveLensV2(
            input: { lensCompoundId: $lensCompoundId, organizationId: $organizationId, vendorData: $vendorData }
        ) {
            lens {
                name
                iconUrl
                vendorData {
                    key
                    value
                }
                ...LensCompoundId
            }
        }
    }
    ${lensCompoundIdFragment}
`;
